import Chip from "../Chip";
import { aiSuggestionLabel, verdictColor } from "./aiReviewText";

// Compact, single-line AI result for list tables.
const AiReviewBadge = ({ aiReview, reviewStatus }) => {
    const ai = aiReview || {};
    let text;
    let color = "inactive";
    if (!ai.status) text = reviewStatus === "pending" ? "Waiting for AI" : null;
    else if (ai.status === "processing") text = "AI checking";
    else if (ai.status === "error") text = "AI failed";
    else if (ai.actionStatus === "done") { text = ai.action === "approve" ? "Auto-approved" : "Auto-rejected"; color = verdictColor(ai.verdict); }
    else { const l = aiSuggestionLabel(ai); text = `AI: ${l.text} ${ai.confidence}%`; color = l.color; }
    if (!text) return <span className="text-gray-400 text-sm">-</span>;
    return <span className="whitespace-nowrap inline-block"><Chip value={text} color={color} small={true} /></span>;
};

export default AiReviewBadge;
